import config from '@/config'

export default function setDocumentTitle(title: string, noSubFix?: boolean) {
  let documentTitle = title
  if (!noSubFix) {
    documentTitle = `${title} - ${config.documentTitleSuffix}`
  }

  const newTitle = documentTitle || config.documentTitleSuffix

  if (newTitle !== document.title) {
    document.title = newTitle
  }
}
